import React, { useEffect, useRef, useState } from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';

function ActiveTendersMap({
  position = { lat: 40.505, lng: -0.09 },
  tenders = [],
}) {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script-main',
    googleMapsApiKey: googleMapsApiKey,
  });

  const [markers, setMarkers] = useState([]);
  const mapRef = useRef(null);

  const [currentLocation, setCurrentLocation] = useState(position);
  const [showingLocation, setShowingLocation] = useState(position);

  useEffect(() => {
    const tempMarkers =
      tenders && Array.isArray(tenders) && tenders.length > 0
        ? tenders.map((item, index) => ({
            position: {
              lat: item?.lat ? parseFloat(item.lat) : 0.0,
              lng: item?.lng ? parseFloat(item.lng) : 0.0,
            },
            id: index, // Unique identifier for each marker
          }))
        : [];

    if (position?.lat && position?.lng) {
      setCurrentLocation({ lat: position.lat, lng: position.lng });
      setShowingLocation({ lat: position.lat, lng: position.lng });
      setTimeout(() => {
        setMarkers(tempMarkers);
      }, 500); // Delay to ensure markers are set after loading
    }
  }, [position, tenders]);

  return isLoaded && currentLocation?.lat && currentLocation?.lng ? (
    <GoogleMap
      id="google-map-script-main"
      ref={mapRef}
      mapContainerStyle={containerStyle}
      center={{
        lat: showingLocation?.lat,
        lng: showingLocation?.lng,
      }}
      zoom={3}
      options={{
        disableDefaultUI: true,
        mapTypeControl: false,
        zoomControl: false,
        zoom: false,
        maxZoom: 3,
        minZoom: 3,
        styles: [
          {
            featureType: 'all',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'administrative',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
        ],
      }}
    >
      {/* Render markers dynamically */}
      {markers.map((marker) => (
        <Marker key={marker.id} position={marker.position} />
      ))}
    </GoogleMap>
  ) : (
    <></>
  );
}

export default React.memo(ActiveTendersMap);

const containerStyle = {
  width: '100%',
  minHeight: '80vh',
  height: '100%',
};

const googleMapsApiKey = 'AIzaSyBn_AmdekbA79CHvrv2O1IdDxoHcbJY0jk';
